import { useState } from 'react';
import PropTypes from 'prop-types';

import { FilterListIcon } from 'src/components/assets/icons';

import {
  TableRow,
  TableCell,
  TableHead,
  Box,
  Button,
  MenuItem,
  InputLabel,
  Modal,
  Select,
  Checkbox,
  SearchIcon,
  TextField,
  IconButton,
  Popover,
} from 'src/components/ui';
import { useGetInventories } from 'src/components/hooks';
import { DatePicker } from '@mui/x-date-pickers';
import { useSpinner } from 'src/components/hooks/useExtraStore';

const columns = [
  { id: 1, label: 'Type', property: 'type' },
  { id: 2, label: 'Category', property: 'category' },
  { id: 3, label: 'Name', property: 'name' },
  { id: 4, label: 'Available Date' },
  { id: 5, label: 'Quantity', property: 'quantity' },
  { id: 6, label: 'Status', property: 'status' },
  { id: 7, label: 'Actions' },
];

export const InventoryHead = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchColumn, setSearchColumn] = useState('');
  const { getInventories } = useGetInventories();
  const { setSpinner } = useSpinner();

  const handleSearch = (e) => {
    setSpinner(true);
    const query = `${searchColumn}=${e}`;

    console.log(query);
    getInventories(0, 5, query);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            sx={{
              width: `${1600 / columns.length}px`,
            }}
          >
            {headCell.label !== 'Actions' && (
              <IconButton
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setSearchColumn(headCell.property);
                }}
              >
                <FilterListIcon />
              </IconButton>
            )}
            <Box sx={{ height: 50 }}>{headCell.label}</Box>
          </TableCell>
        ))}
      </TableRow>

      <Popover
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
        }}
        transformOrigin={{
          vertical: 'top',
        }}
      >
        {(searchColumn === 'category' || searchColumn === 'quantity') && (
          <Box
            sx={{
              bgcolor: 'background.paper',
              borderRadius: '14px',
              padding: '10px',
              display: 'flex',
              width: '300px',
            }}
          >
            <TextField
              autoFocus
              label={`Search ${searchColumn}`}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                style: {
                  height: '10px',
                },
              }}
              sx={{ width: '100%' }}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Box sx={{ marginLeft: '10px' }}>
              <IconButton
                onClick={() => {
                  setAnchorEl(null);
                  getInventories(0, 5);
                }}
                size="small"
              >
                <Box
                  sx={{
                    paddingInline: '10px',
                    paddingBlock: '6px',
                    background: 'red',
                    borderRadius: '8px',
                    color: 'white',
                  }}
                >
                  x
                </Box>
              </IconButton>
            </Box>
          </Box>
        )}

        {searchColumn === 'type' && (
          <Box sx={{ padding: '14px' }}>
            <Box sx={{ display: 'flex' }}>
              <Select
                sx={{ width: '140px' }}
                onChange={(e) => handleSearch(e.target.value)}
                displayEmpty
                renderValue={() => {
                  return 'Type';
                }}
              >
                <MenuItem key="accountType1" value="product">
                  Product
                </MenuItem>
                <MenuItem key="accountType2" value="plan">
                  Plan
                </MenuItem>
                <MenuItem key="accountType2" value="resource">
                  Resource
                </MenuItem>
              </Select>
              <Box sx={{ marginLeft: '10px' }}>
                <IconButton
                  onClick={() => {
                    setAnchorEl(null);
                    getInventories(0, 5);
                  }}
                  size="small"
                >
                  <Box
                    sx={{
                      paddingInline: '10px',
                      paddingBlock: '6px',
                      background: 'red',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    x
                  </Box>
                </IconButton>
              </Box>
            </Box>
          </Box>
        )}

        {searchColumn === 'status' && (
          <Box sx={{ padding: '14px' }}>
            <Box sx={{ display: 'flex' }}>
              <Select
                sx={{ width: '140px' }}
                onChange={(e) => {
                  handleSearch(e.target.value);
                }}
                displayEmpty
                renderValue={(selected) => {
                  return 'Status';
                }}
              >
                <MenuItem key="Active" value="Active">
                  Active
                </MenuItem>
                <MenuItem key="Disabled" value="Disabled">
                  Disabled
                </MenuItem>
              </Select>
              <Box sx={{ marginLeft: '10px' }}>
                <IconButton
                  onClick={() => {
                    setAnchorEl(null);
                    getInventories(0, 5);
                  }}
                  size="small"
                >
                  <Box
                    sx={{
                      paddingInline: '10px',
                      paddingBlock: '6px',
                      background: 'red',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    x
                  </Box>
                </IconButton>
              </Box>
            </Box>
          </Box>
        )}

        {(searchColumn === 'requestedDate' || searchColumn === 'lastSeen') && (
          <Box sx={{ padding: '14px' }}>
            <Box sx={{ display: 'flex' }}>
              <DatePicker
                label={`Select ${searchColumn}`}
                onChange={(date) => {
                  if (date) {
                    const formattedDate = date.toLocaleDateString('en-CA');
                    handleSearch(formattedDate);
                  }
                }}
              />
              <Box sx={{ marginLeft: '10px' }}>
                <IconButton
                  onClick={() => {
                    setAnchorEl(null);
                    getInventories(0, 5);
                  }}
                  size="small"
                >
                  <Box
                    sx={{
                      paddingInline: '10px',
                      paddingBlock: '6px',
                      background: 'red',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    x
                  </Box>
                </IconButton>
              </Box>
            </Box>
          </Box>
        )}
      </Popover>
    </TableHead>
  );
};

InventoryHead.propTypes = {
  // handleSearch: PropTypes.func,
};
